<template lang="pug">
	ol.breadcrumb
		li.breadcrumb-item(:key="index" v-for="(routeObject, index) in routeRecords" :class="isLast(index)?'--active':''")
			span.active(v-if="isLast(index)") {{ getName(routeObject) }}
			router-link(:to="routeObject" v-else) {{ getName(routeObject) }}
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    routeRecords() {
      	return this.list.filter((route) => (route.name || route.meta.label) && route.meta.default ? (route.meta.default !==this.$router.currentRoute.name) : true )
    }
  },
  methods: {
    getName (item) {
      return item.meta && item.meta.label ? item.meta.label : item.name || null
    },
    isLast (index) {
      return index === this.routeRecords.length - 1
    }
  }
}
</script>
<style lang="scss">
	.breadcrumb-item {
		white-space: nowrap;
		&.--active {
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}
	}
</style>
